import { Purchase, Tool, UserProfile } from "../interfaces";


export type SessionState = {
    account: UserProfile | null;
    purchase: Purchase | null;
    tool: Tool | null;
};

export type SessionAction =
    | { type: 'TOOL_ADD'; payload: { tool: Tool } }
    | { type: 'TOOL_UPDATE'; payload: { tool: Tool } }
    | { type: 'TOOL_DELETE'; payload: { id: number } }
    | { type: 'PURCHASE_ADD'; payload: { purchase: Purchase } }
    | { type: 'LOGIN'; payload: { account: UserProfile } }
    | { type: 'LOGOUT' };

export const initialSessionState: SessionState = {
    purchase: null,
    tool: null,
    account: null
};

export const sessionReducer = (
    state: SessionState = initialSessionState,
    action: SessionAction
): SessionState => {
    switch (action.type) {
        case 'PURCHASE_ADD':
            return {
                ...state,
                purchase: action.payload.purchase,
            };
        case 'TOOL_ADD':
            return {
                ...state,
                tool: action.payload.tool,
            };
        case 'TOOL_UPDATE':
            return {
                ...state,
                tool: action.payload.tool,
            };
        case 'TOOL_DELETE':
            return {
                ...state,
                tool: null,
            };
        case 'LOGIN':
            return {
                ...state,
                account: action.payload.account
            };
        case 'LOGOUT':
            return {
                ...state,
                account: null,
            };
        default:
            return state;
    }
};
